<template>
  <div>
    <b-row>
      <b-col md="12" style="height: 100% !important">
        <b-card class="card-itens tableItensCompra" style="max-height: 100% !important" id="tableItensCompra">
          <!-- CAMPO DE PERCENTUAL + AVISO -->
          <b-row class="px-3 pt-3" style="margin-bottom: 5px;">
            <b-col cols="12" class="d-flex justify-content-end align-items-center flex-wrap">
              <div class="d-flex align-items-center">
                <b-input-group size="sm" style="max-width: 260px">
                  <b-form-input v-model.number="markupPercent" type="number" min="0" step="0.01"
                    placeholder="% markup sobre o custo" />
                  <b-input-group-append>
                    <b-button variant="success" @click="aplicarMarkup">
                      Aplicar
                    </b-button>
                  </b-input-group-append>
                </b-input-group>

                <b-icon icon="info-circle" variant="primary" class="ml-2" v-b-tooltip.left="'Informe o percentual de markup que será aplicado sobre o custo atual dos itens selecionados para formar o novo preço de venda.'
                  " />
              </div>
            </b-col>
          </b-row>
          <!-- FIM BLOCO -->

          <table class="table table-head-custom table-head-bg table-vertical-center" :key="keyToRender">
            <thead>
              <tr>
                <!-- COLUNA SELECIONAR TODOS -->
                <th style="width: 30px; text-align: center;">
                  <b-form-checkbox v-model="selectAll" :indeterminate="isIndeterminate"
                    @change="handleToggleSelectAll" />
                </th>

                <!-- COLUNA NUMERAÇÃO / CÓDIGO -->
                <th></th>

                <th class="pl-0 font-weight-bold text-muted pl-7">
                  Itens Nota
                </th>
                <th class="pl-0 font-weight-bold text-muted pl-7">
                  Custo Últ.Compra
                </th>
                <th class="pl-0 font-weight-bold text-muted pl-7">
                  Custo Atual
                </th>
                <th class="pl-0 font-weight-bold text-muted pl-7">
                  Preço Venda
                  <b-icon icon="info-circle" variant="primary" v-b-tooltip.left="'Caso preencher o preço de venda o mesmo já irá atualizar no seu estoque'
                    "></b-icon>
                </th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(i, index) in items" :key="'item' + index">
                <!-- CHECKBOX POR LINHA -->
                <td style="width: 30px; text-align: center;">
                  <b-form-checkbox v-model="selectedIndexes" :value="index" />
                </td>

                <!-- NUMERAÇÃO / CÓDIGO -->
                <td style="font-size: 12px; width: 50px">
                  {{ parseFloat(index + 1) }} /
                  <strong style="font-size: 10px">
                    {{ i.cod_importacao }}
                  </strong>
                </td>

                <!-- COLUNA ITENS NOTA -->
                <td class="pl-0" style="font-size: 12px; width: 400px">
                  <div>
                    <!-- Produto NOVO: input + chip "Novo" lado a lado -->
                    <template v-if="!i?.vinculo">
                      <div class="item-desc">
                        <b-form-input class="mt-1" size="sm" :id="`desc-${index}`" v-model="i.produto.descricao"
                          :maxlength="120" placeholder="Descrição do produto (novo)" autocomplete="off" trim
                          @blur="onDescricaoBlur(i)" @keydown.enter.prevent="focusNext(index)" />
                        <span class="chip chip--info" v-b-tooltip.hover.right
                          :title="'Produtos não vinculados serão cadastrados no sistema como produtos novos. Se você já tem esse produto cadastrado, clique em “Vincular” e faça o vínculo com esse item.'">
                          Novo
                        </span>
                      </div>
                    </template>

                    <!-- Vinculado: texto + chip "Vinculado" e referência do produto -->
                    <template v-else>
                      <div class="item-desc">
                        <span class="mb-0">{{ i.produto.descricao }}</span>
                        <span class="chip chip--success">Vinculado</span>
                      </div>
                      <span class="text-muted" style="font-size: 12px">
                        {{ i.vinculoProduto.codigo }} -
                        {{ i.vinculoProduto.descricao }}
                      </span>
                    </template>
                  </div>
                </td>
                <!-- FIM COLUNA ITENS NOTA -->

                <td style="width: 150px">
                  <money disabled v-if="i.vinculo" class="form-control" :value="parseFloat(i.custo_ultima_compra)"
                    @input="(value) => (i.custo_ultima_compra = value)" v-bind="priceOptions"></money>
                </td>

                <td style="width: 150px" v-b-tooltip.hover.left="'Soma do valor unitário do item + Frete + IPI + Despesas + ICMS ST - Descontos'
                  ">
                  <money disabled class="form-control" :value="parseFloat(i.custo)"
                    @input="(value) => (i.custo = value)" v-bind="priceOptions"></money>
                </td>

                <td style="width: 150px">
                  <money v-if="!i.vinculo" class="form-control" :value="parseFloat(i.preco)"
                    @input="(value) => (i.preco = value)" v-bind="priceOptions"></money>
                  <money :disabled="i.vinculoProduto && i.vinculoProduto.markup > 0" v-else class="form-control"
                    :value="parseFloat(i.vinculoProduto.preco)" @input="(value) => (i.vinculoProduto.preco = value)"
                    v-bind="priceOptions"></money>
                </td>

                <td style="width: 100px">
                  <b-button variant="primary" href="javascript:;" @click="handleOpenVinculo(i, index)">
                    {{ !i?.vinculo ? "Vincular" : "Desvincular" }}
                  </b-button>
                </td>
              </tr>
            </tbody>
          </table>
        </b-card>
        <blockquote />
      </b-col>
    </b-row>

    <b-modal id="vincular-itens" title="Vincular/Desvincular item" size="md" centered>
      <h5 style="text-align: center; margin-bottom: 2rem">
        Busque o produto que deseja vincular com o item:
        <span style="font-weight: normal">
          {{ produtoParaVincular?.descricao }}
        </span>
      </h5>

      <VueSelect ref="buscarProduto" :filterable="false" :options="produtos" @search="onSearchProduto"
        @input="handleSelectProduto" :value="produtoParaVincular && produtoParaVincular.vinculoProduto"
        v-if="produtoParaVincular" :disabled="produtoParaVincular && produtoParaVincular.vinculoProduto">
        <template slot="no-options"> Informe a descrição do produto </template>

        <template slot="option" slot-scope="option">
          <div class="d-center">
            {{ option.codigo }} - {{ option.descricao }}
          </div>
        </template>

        <template slot="selected-option" slot-scope="option">
          <div class="selected d-center">
            {{ option.codigo }} - {{ option.descricao.slice(0, 30) }}
          </div>
        </template>
      </VueSelect>

      <template #modal-footer="{ ok, cancel }">
        <b-button @click="
          () => {
            cancel();
          }
        ">Cancelar</b-button>
        <b-button v-if="vinculoProduto" variant="danger" ref="desvincular-button" @click="
          () => {
            desvincularItem();
            ok();
          }
        ">
          Desvincular
        </b-button>
        <b-button variant="success" v-if="!vinculoProduto" ref="vincular-button" @click="
          () => {
            vincularItem();
            ok();
          }
        ">
          Vincular
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import { SistemaMixin } from "@/modules/Application";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { Money } from "v-money";
import { priceOptions } from "@/modules/Application";
import { mapActions } from "vuex";

export default {
  name: "compra-card-itens",
  components: {
    VueSelect,
    Money,
  },
  mixins: [SistemaMixin],
  data() {
    return {
      calculoTotal: 0,
      produtos: [],
      priceOptions,
      produtoParaVincular: null,
      keyToRender: 0,
      selectedItem: 0,
      vinculoProduto: null,

      // Percentual de markup
      markupPercent: null,

      // Seleção de itens
      selectedIndexes: [],
      selectAll: false,

    };
  },
  props: {
    items: {
      default: [],
    },
    total: {
      default: 0,
    },
  },
  computed: {
    // estado indeterminado do "selecionar todos"
    isIndeterminate() {
      return (
        this.selectedIndexes.length > 0 &&
        this.selectedIndexes.length < this.items.length
      );
    },
  },
  methods: {
    ...mapActions(["setLoading"]),

    // Normaliza descrição e emite alteração para o pai
    onDescricaoBlur(i) {
      const raw = i?.produto?.descricao || "";
      const normalized = raw.replace(/\s+/g, " ").trim().toUpperCase();
      i.produto.descricao = normalized;
      this.$emit("onItemsChange", this.items);
    },

    // Enter foca no próximo input de descrição
    focusNext(idx) {
      const next = this.$el.querySelector(`#desc-${idx + 1}`);
      if (next) next.focus();
    },

    // Arredonda 2 casas
    roundMoeda(value) {
      if (value === null || value === undefined || value === "") return 0;
      const num = parseFloat(value);
      if (isNaN(num)) return 0;
      return Math.round(num * 100) / 100;
    },

    // Selecionar / desmarcar todos
    handleToggleSelectAll(checked) {
      if (checked) {
        this.selectedIndexes = this.items.map((_, idx) => idx);
      } else {
        this.selectedIndexes = [];
      }
    },

    // Aplica o markup somente nos itens selecionados
    async aplicarMarkup() {
      if (this.markupPercent === null || this.markupPercent === "") {
        this.$toast.warning("Informe um percentual para aplicar.");
        return;
      }

      const perc = parseFloat(this.markupPercent);
      if (isNaN(perc)) {
        this.$toast.error("Percentual inválido.");
        return;
      }

      if (!this.selectedIndexes.length) {
        this.$toast.warning(
          "Selecione ao menos um item na tabela para aplicar o markup."
        );
        return;
      }

      const qtd = this.selectedIndexes.length;

      // Confirmação
      const confirmed = await this.$bvModal.msgBoxConfirm(
        `Será aplicado um markup de ${perc}% sobre o custo atual de ${qtd} item(ns) selecionado(s). Deseja continuar?`,
        {
          title: "Confirmar aplicação de markup",
          size: "md",
          buttonSize: "sm",
          okVariant: "success",
          okTitle: "Sim, aplicar",
          cancelTitle: "Cancelar",
          footerClass: "p-2",
          centered: true,
        }
      );

      if (!confirmed) return;

      const fator = 1 + perc / 100;

      this.selectedIndexes.forEach((idx) => {
        const i = this.items[idx];
        if (!i) return;

        const custoBase = parseFloat(i.custo) || 0;
        if (!custoBase || custoBase <= 0) {
          return; // pula itens sem custo
        }

        const novoPreco = this.roundMoeda(custoBase * fator);

        // Produto sem vínculo -> usa i.preco
        if (!i.vinculo) {
          i.preco = novoPreco;
          return;
        }

        // Produto vinculado -> usa vinculoProduto.preco
        if (i.vinculo && i.vinculoProduto) {
          // Se quiser pular quem já tem markup cadastrado:
          // if (i.vinculoProduto.markup > 0) return;

          i.vinculoProduto.preco = novoPreco;
          i.vinculoProduto.markup = perc; // opcional
        }
      });

      this.$emit("onItemsChange", this.items);
      this.$toast.success(
        `Markup de ${this.markupPercent}% aplicado sobre o custo atual de ${qtd} item(ns) selecionado(s).`
      );

      // 👉 limpa seleção após aplicar
      this.selectedIndexes = [];
      this.selectAll = false;
    },


    async vincularItem() {
      if (!this.produtoParaVincular) {
        this.$toast.warning("Selecione um produto para vincular!");
        return;
      }
      this.setLoading(true);
      try {
        const data = {};
        data.codigo_importacao = this.produtoParaVincular.cod_importacao;
        data.id = this.produtoParaVincular.vinculoProduto?.id ?? null;
        await this.$http.post("/produtos/vincular-produto", data);
        this.items[this.produtoParaVincular.index].vinculo = true;
        this.items[this.produtoParaVincular.index].vinculoProduto =
          this.produtoParaVincular.vinculoProduto;
        this.$emit("onItemsChange", this.items);
        this.$toast.success("Produto vinculado com sucesso!");
        this.keyToRender = this.keyToRender + 1;
      } catch (error) {
        console.log(error);
      }
      this.setLoading(false);
    },

    async desvincularItem() {
      if (!this.produtoParaVincular) {
        this.$toast.warning("Este item não possui vínculo!");
        return;
      }
      this.setLoading(true);
      try {
        const data = {};
        data.codigo_importacao = null;
        data.id = this.produtoParaVincular?.vinculoProduto?.id ?? null;
        await this.$http.post("/produtos/desvincular-produto", data);
        this.items[this.produtoParaVincular.index].vinculo = false;
        this.items[this.produtoParaVincular.index].vinculoProduto = null;
        this.$toast.success("Produto desvinculado com sucesso!");
        this.keyToRender = this.keyToRender + 1;
        this.$emit("onItemsChange", this.items);
        this.produtoParaVincular = null;
      } catch (error) {
        console.log(error);
      }
      this.setLoading(false);
    },

    handleOpenVinculo(produto, index) {
      this.selectedItem = index;
      this.produtoParaVincular = {
        ...produto,
        index,
        descricao: produto.produto.descricao,
      };
      this.vinculoProduto = !!produto?.vinculoProduto;
      this.$bvModal.show("vincular-itens");
    },

    handleSelectProduto(produto) {
      this.produtoParaVincular = {
        ...this.produtoParaVincular,
        vinculoProduto: produto,
      };
    },

    onSearchProduto(search, loading) {
      if (search.length) {
        loading(true);
        this.searchProduto(loading, search, this);
      }
    },

    searchProduto: _.debounce(async (loading, search, vm) => {
      vm.produtos = await vm.getProdutoByDescricao(search);
      loading(false);
    }, 350),

    valorReal(valor = 0) {
      return valor.toLocaleString("pt-br", {
        minimumFractionDigits: 2,
      });
    },
  },
  watch: {
    total(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.calculoTotal = newValue;
      }
    },
    // Mantém o "selecionar todos" em sincronia com a seleção manual
    selectedIndexes(newVal) {
      if (!this.items.length) {
        this.selectAll = false;
        return;
      }
      if (newVal.length === this.items.length) {
        this.selectAll = true;
      } else if (newVal.length === 0) {
        this.selectAll = false;
      }
    },
  },
};
</script>

<style>
/* ====== ajustes de layout para input + selo ====== */
.item-desc {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.item-desc .form-control {
  flex: 1 1 260px;
}

/* Chip genérico */
.chip {
  display: inline-flex;
  align-items: center;
  padding: 0 10px;
  height: 22px;
  line-height: 22px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
  border: 1px solid transparent;
}

.chip--info {
  color: #17a2b8;
  border-color: #17a2b8;
  background: rgba(23, 162, 184, 0.06);
}

.chip--success {
  color: #28a745;
  border-color: #28a745;
  background: rgba(40, 167, 69, 0.06);
}

/* ====== originais (mantidos) ====== */
.produtoBusca .vs__dropdown-menu {
  width: 700px;
  left: -200px !important;
}

.card-titulo-itens .card-title {
  margin-bottom: 0 !important;
  font-weight: 700;
  font-size: 1.75rem;
  padding: 0.75rem;
}

.card-titulo-itens .card-body {
  padding: 0.45rem;
}

.card-titulo-itens {
  background-color: #fff;
  border: 0px;
  text-align: center;
  margin-bottom: 0px;
  padding: 0;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}

.card-itens .card-body {
  padding: 0;
}

.table {
  border-bottom: solid 0px #dedede;
  margin-bottom: 0px;
}

.tableItensCompra {
  border: 0px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
}

.tableItensCompra th,
.tableItensCompra td {
  padding: 8px 16px;
}

.tableItensCompra .table tr th {
  border-bottom: 2px solid var(--color-primary);
}

.tableItensCompra th {
  position: sticky;
  top: 0;
  background: #fff;
}

::-webkit-scrollbar {
  width: 5px;
}

::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 1px;
}

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 200px rgb(229 245 234 / 19%);
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--color-secondary);
}

.card-total-venda {
  background: transparent;
  border: 0px;
  top: 30px;
}

.card-total-venda .card-body {
  padding: 0rem 1rem 0rem 1rem;
}

.card-total-left {
  background-color: var(--color-primary);
  border-color: var(--color-primary);
  color: #fff;
  border-radius: 0px;
  border-bottom-left-radius: 20px !important;
  height: 90px;
  width: 101%;
  display: table;
  text-align: left;
}

.card-total-left .card-body {
  display: table-cell;
  vertical-align: middle;
}

.card-total-right {
  background-color: var(--color-secondary);
  border-color: var(--color-secondary);
  color: #fff;
  border-radius: 0px;
  align-items: flex-end;
  border-bottom-right-radius: 20px !important;
  height: 90px;
  width: 100%;
  display: table;
  text-align: center;
  text-align: right;
}

.card-total-right .card-body {
  display: table-cell;
  vertical-align: middle;
}

.card-total-right p,
.card-total-left p {
  margin-bottom: 0;
  font-size: 0.8rem;
}

.card-total-right h5,
.card-total-left h5 {
  font-size: 1.75rem !important;
  margin-bottom: 0;
}

.tableItensCompra tbody tr {
  border-top-width: 1.5px;
  border-top-color: var(--color-primary);
}

blockquote {
  margin: 0 auto;
  position: relative;
  text-align: center;
  z-index: 1;
}

blockquote:after {
  content: "";
  display: block;
  position: absolute;
  width: 100%;
  height: 29px;
  right: 0;
  bottom: -24px;
  left: 0;
  padding-top: 10px;
  background: linear-gradient(-45deg, transparent 70%, white 75%),
    linear-gradient(45deg, transparent 70%, white 75%);
  background-repeat: repeat-x;
  background-size: 25px 20px, 25px 20px;
  background-position: center;
}
</style>
